<div class="card p-3 border-2 top-products-container">
  <div class="card-header flex justify-content-between align-items-center h-2rem mb-2">
    <div class="title text-base font-medium pl-2">{{ topProducts.title }}</div>
    <div class="flex justify-content-end align-items-center h-2rem gap-2 pr-2">
      <div class="h-2rem w-2rem">
        @if (currentPage > 0) {
          <geaui-button-v3
            class="nav-icons"
            (click)="onCarouselPagePrev()"
            size="small"
            type="tertiary"
            preIcon="chevron-left"></geaui-button-v3>
        }
      </div>

      @if (topProducts.products.length > 1) {
        <div class="circle-selectors flex justify-content-end align-items-center gap-1">
          @for (product of topProducts.products; track product; let i = $index) {
            <a class="circle cursor-pointer" [ngClass]="{ 'selected-product': i === currentPage }" (click)="currentPage = i"></a>
          }
        </div>
      }

      <div class="h-2rem w-2rem">
        @if (currentPage < topProducts.products.length - 1) {
          <geaui-button-v3
            class="nav-icons"
            (click)="onCarouselPageNext()"
            size="small"
            type="tertiary"
            preIcon="chevron-right"></geaui-button-v3>
        }
      </div>
    </div>
  </div>
  @if (!topProducts.products || topProducts.products.length === 0) {
    @if (isLoading()) {
      <p-skeleton height="2rem" width="100%"></p-skeleton>
    } @else {
      <span class="ml-2 text-4xl font-medium">0</span>
    }
  } @else {
    <p-carousel
      class="p-carousel-text"
      [value]="topProducts.products"
      [page]="currentPage"
      [showIndicators]="false"
      [showNavigators]="false">
      <ng-template #item let-item>
        <div
          class="flex carousel-content gap-3 justify-content-start align-items-center cursor-pointer"
          (click)="goToProductsPage(item)">
          <span class="top-products-count-container ml-2 flex align-items-center p-1" [ngClass]="getProductCrownClass(item)">
            <i class="pi pi-crown text-base"></i>
            <span class="top-products-count pl-1 font-medium gea-font-subline-16">{{
              topProducts.products.indexOf(item) + 1
            }}</span>
          </span>
          <span class="align-items-center">{{ item.name }}</span>
        </div>
      </ng-template>
    </p-carousel>
  }
</div>
